module.exports = __webpack_public_path__ + "static/DJS1-f51df2f7038920ed2560140b8814e41a.png";